import type { Auth0ContextInterface, User } from "@auth0/auth0-react";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { QueryClient } from "@tanstack/react-query";


export type RouterContext = {
	queryClient: QueryClient;
	auth0?: Auth0ContextInterface<User>
};

export const Route = createRootRouteWithContext<RouterContext>()({
	component: () => <Outlet />
});